{
  "name": "app-stock-sgcap",
  "version": "1.1.0",
  "private": true,
  "description": "Sistema de gestión de stock - Monorepo",
  "workspaces": [
    "backend",
    "sgcap-stock"
  ],
  "scripts": {
    "install:all": "pnpm install",
    "dev": "concurrently -n api,web -c blue,magenta \"pnpm --filter @app-stock/api dev\" \"pnpm --filter @app-stock/web dev\"",
    "dev:api": "pnpm --filter @app-stock/api dev",
    "dev:web": "pnpm --filter @app-stock/web dev",
    "start": "pnpm -r run start",
    "start:api": "pnpm --filter @app-stock/api start",
    "start:web": "pnpm --filter @app-stock/web start",
    "build": "pnpm -r run build",
    "build:api": "pnpm --filter @app-stock/api build",
    "build:web": "pnpm --filter @app-stock/web build",
    "test": "pnpm -r run test",
    "test:api": "pnpm --filter @app-stock/api test",
    "test:web": "pnpm --filter @app-stock/web test",
    "docker:up": "docker-compose -f docker-compose.dev.yml up -d",
    "docker:down": "docker-compose -f docker-compose.dev.yml down",
    "docker:logs": "docker-compose -f docker-compose.dev.yml logs -f db",
    "docker:restart": "docker-compose -f docker-compose.dev.yml restart db",
    "clean": "rm -rf node_modules backend/node_modules sgcap-stock/node_modules"
  },
  "packageManager": "pnpm@9.15.4",
  "keywords": [
    "stock",
    "inventory",
    "monorepo",
    "angular",
    "express"
  ],
  "author": "",
  "license": "ISC",
  "devDependencies": {
    "concurrently": "^8.2.2"
  }
}
